<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="manufacturer-main-sidebar" position="left" lockedOpen="gt-md">
        <gallery-main-sidebar></gallery-main-sidebar>
    </fuse-sidebar>

    <div class="center">

        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
            <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                  fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                <div class="h2 mb-24">{{'Gallery data'|translate}}</div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                        <mat-label>{{'Name'|translate}}</mat-label>
                        <input matInput formControlName="name" required>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>{{'Name is required!'|translate}}</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                        <mat-label>{{'Tag name'|translate}}</mat-label>
                        <input matInput formControlName="tagName" required>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>{{'Tag name is required!'|translate}}</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-checkbox formControlName="active" fxFlex="100">
                        <mat-label>{{'Is active'|translate}}</mat-label>
                    </mat-checkbox>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-checkbox formControlName="mobileApplicationStartScreen" fxFlex="100">
                        <mat-label>{{'Mobile application start screen'|translate}}</mat-label>
                    </mat-checkbox>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button mat-raised-button type="submit" color="accent">
                            {{'Save'|translate}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
